import { Injectable } from '@angular/core';

import { RouterExtensionService } from '@alfresco/aca-shared';

@Injectable({
  providedIn: 'root',
})
export class WkRouterExtensionService {
  constructor(
    private readonly routerExtensionService: RouterExtensionService
  ) {}

  mapExtensionRoutes(): void {
    return this.routerExtensionService.mapExtensionRoutes();
  }
}
